import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import { Tooltip, makeStyles } from '@material-ui/core'
import Icon from '@components/std-components/Icons'
import { useTranslation } from 'react-i18next'
import { CopyTemplateImg, PasteTemplateImg, RollUpImg } from '@resources/images'
import Button from '@components/std-components/Button'

interface IAProductQuantityActionsProps {
  disableRollUp: boolean
  rollUpIAProductQuantity: () => void
}
const useStyles = makeStyles(theme => ({
  rootContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center',
    height: 55,
    '& .button + .button': {
      marginLeft: 4
    }
  },
  actionBtn: {
    marginLeft: 4,
    '& .icon': {
      cursor: 'inherit'
    }
  }
}))

const IAProductQuantityActions: FC<IAProductQuantityActionsProps> = ({
  disableRollUp,
  rollUpIAProductQuantity
}) =>
  useObserver(function useHook() {
    const classes = useStyles()
    const { t } = useTranslation()

    return (
      <div className={classes.rootContainer} data-test-id='IAProductQuantityActions'>
        <Button
          variant='link'
          size='none'
          disabled={disableRollUp}
          className={classes.actionBtn}
          onClick={rollUpIAProductQuantity}
        >
          <Tooltip title={t('order.rollUp', 'Roll Up')}>
            <div>
              <Icon imageSrc={RollUpImg} alt={'rollUp'} />
            </div>
          </Tooltip>
        </Button>
        <Button
          variant='link'
          size='none'
          className={classes.actionBtn}
          style={{ display: 'none' }}
        >
          <Tooltip
            title={t('order.quantitiesAndBook.copyToTemplate', 'Copy As Template')}
          >
            <div>
              <Icon imageSrc={CopyTemplateImg} alt={'copyTemplate'} />
            </div>
          </Tooltip>
        </Button>
        <Button
          size='none'
          variant='link'
          className={classes.actionBtn}
          style={{ display: 'none' }}
        >
          <Tooltip
            title={t('order.quantitiesAndBook.pasteFromTemplate', 'Paste From Template')}
          >
            <div>
              <Icon imageSrc={PasteTemplateImg} alt={'pasteTemplate'} />
            </div>
          </Tooltip>
        </Button>
      </div>
    )
  })

export default IAProductQuantityActions
